import {Component} from "@angular/core";
@Component({
  template: `
        <div class="big-flow">
       
        <div class="middle-box"><br>
        <h2>商品訂購指南</h2><br>
        <div class="line-flow"></div><br>
        <p>此網站僅提供會員購物，"非"會員預購物請參考以下方式至另一平台即可進行購物<br><br>
        對於此網站購物有任何疑問請來電網購客服專線(02)3151-3888或<br><br>
        來信majestic168168@gmail.com詢問，將有專人為您服務～祝您購物愉快！！


        </p>
        </div></div>
        
        <div class="container">
        <div class="title-clothes">
        <div class="title-clothes-line"></div>會員註冊說明<div class="title-clothes-line2"></div>
        <div class="money-confirm money-expla">
   
        <h2>1.會員註冊<br>
        <span class="black-money money-explaContent">只需填寫”姓名”及”電子信箱”即可註冊成為會員並享有此網站的購物功能, 輕鬆下單、省時有效率
</span></h2>
        <h2>2.會員等級<br>
        <span class="black-money money-explaContent">
        A.一般會員<br>
凡註冊成功立即成為一般會員</span>
<br><br>
<span class="black-money money-explaContent">
B."VIP"會員<br>
凡單筆消費達8000元或累計消費達15000元者, 會員等級將從”一般會員”升級成為”VIP”會員, VIP會員即享有VIP購物優惠 (若符合以上資格但會員等級尚未變更者煩請至電告知), 

        </span>
        </h2>
        </div>
        </div>
        <div class="title-clothes">
        
        <div class="title-clothes-line"></div>購物訂單說明<div class="title-clothes-line2"></div>
        <div class="subtitle">本店無國外寄送服務, 且不接受外國銀行(如：星展...)帳戶匯款, 如有不便 敬請見諒</div>
        <div class="money-confirm money-expla">
        <h2>1.付款＆取貨方式: <br><span class="black-money money-explaContent">轉帳匯款<br>
待入帳並確認金額無誤後即出貨<br>
(可利用以下三種方式)<br>
1.ATM轉帳(最快速便利)<br>
2.銀行匯款 (至各地銀行填寫匯款單)<br>
3.無摺存款 (至郵局辦理)<br>

</span></h2>
        <h2>2.地址/店名 : <br><span class="black-money money-explaContent">- 便利商店取貨請填寫取貨店名</span><br><span class="black-money money-explaContent">- 使用郵局寄送請填寫收件地址</span></h2>
        <h2>3.給賣家的話 : <span class="black-money money-explaContent"><br>
若購買商品有不同規格，請於此處留言告知商品規格<br>
EX:<br>
拍柄尺寸＝>FL/ST/AN<br>
膠皮=>紅/黑</span></h2>
        <h2>4.運費 :<span class="black-money money-explaContent"><br>
- 當次購物總金額未滿1200元須加收運費元, 超過1200元免運費(運費將自動減免,球桌除外)<br>
***運費：新北＆台北郵寄運費一律70元, 外縣市一律80元***<br>
- 球桌下訂前請先來電詢問是否有貨及確認運費<br>
<a href="https://drive.google.com/file/d/1JvSxanIv7i-Xc_4gZrQ_rPzjYc_k4wQ-/view?usp=share_link" target="_blank">*** 球桌運送服務及費用說明 ***</a>

</span></h2>
        <h2>5.備註 : <span class="black-money money-explaContent"><br>當您在本網站完成訂購手續後，本系統會自動發送訂購明細於會員專區，但該項通知只是確認本系統已經收到您的訂單，不代表本交易已經完成或契約已經成立，本網站將保留是否接受您訂單的權利。如果商品確有庫存、交易條件正確且已完成付款手續，本網站將盡快安排出貨，並發送通知給您。
</span></h2>

        </div>

        </div>
        
        <div class="title-clothes">
        <div class="title-clothes-line"></div>轉帳匯款<div class="title-clothes-line2"></div>
       
        </div>
         <div class="subtitle">請於下單後三日內完成匯款並填寫匯款通知</div><br>
        <div class="pay-method">    
        
        <div class two-flow>
        <div class="left-flow">(1)立帳郵局：台北松山郵局 代號：700<br>
帳號:0001180-0910141<br>
戶名 : 鄒雅文<br>
</div>
        <div class="right-flow">(2)銀行 : 合作金庫---城東分行(代號006)<br>
帳號:0600-717-932762<br>
戶名 : 波爾桌球用品社<br>
</div>
        </div><br>
        
        <p></p>
        <br>
        
       
        </div>
        <div class="title-clothes">
        <div class="title-clothes-line"></div>轉帳金額確認<div class="title-clothes-line2"></div>
        </div>
        <div class="subtitle">匯款後請至“匯款通知”填寫匯款確認單（"貨到付款"無須填寫）</div><br>
        <div class="money-confirm"> 
        <h2>1.ATM轉帳 : <span class="black-money">請告知轉帳金額及帳號後五碼。</span></h2>
        <h2>2.無摺存款 : <span class="black-money">填寫轉帳金額及您辦理無折存款的該間郵局局號</span></h2>
        <h2>3.銀行匯款 : <span class="black-money">請填寫轉帳金額及您的姓名即可。</span></h2>
        </div>
        
        <div class="title-clothes">
        <div class="title-clothes-line"></div>出貨<div class="title-clothes-line2"></div>
        </div>
        <div class="deliver">   
        出貨中心確認訂單及轉帳資料無誤後,將立即出貨,物品約於轉帳日3~6天後(不含例假日、休息日及國定假日)收到<br>
任何出貨問題歡迎電話至服務專線(02)3151-3888

        
        </div>
        
        
        </div>
        
        
        
    `,

})


export class FlowComponent {


}



// WEBPACK FOOTER //
// ./src/app/Flow/flow.component.ts